
import React from 'react';
import { Field } from 'formik';
import { Row, Col, FormGroup, Input, Label, FormFeedback, Modal, ModalFooter, Button, Fade } from 'reactstrap';

class Page5AgreementPernyataan extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        var pernyataanBox = {
            height: '500px',
            overflow: 'auto',
            backgroundColor: '#fafafa',
            padding: '10px'
        }

        var listLowerAlpha = {
            listStyleType: 'lower-alpha'
        }
        const { onAgree, setFieldValue, errors, touched, values } = this.props;

        return (
            
            <React.Fragment>
               <Fade>

               <FormGroup tag="fieldset">
                 <legend>Ketentuan dan Persyaratan </legend>
                 <div style={pernyataanBox}>
                        <h5>KETENTUAN DAN PERSYARATAN KHUSUS PEMBUKAAN
REKENING DANA NASABAH (RDN) BRI</h5>
<p>Ketentuan dan Persyaratan Khusus Pembukaan Rekening Dana Nasabah ini
(berikut semua lampiran, perubahan dan atau pembaharuannya selanjutnya
disebut “KPK Rekening Dana Nasabah”) adalah ketentuan khusus terkait
dengan pembukaan Rekening Dana Nasabah di PT Bank Rakyat Indonesia, Tbk
berkedudukan di Jakarta (“Bank”) yang dibuat dan ditandatangani pada hari dan
tanggal sebagaimana tercantum pada akhir KPK Rekening Dana Nasabah ini
oleh Nasabah (selanjutnya disebut “Nasabah”).<br />
Dengan ditandatanganinya KPK Rekening Dana Nasabah ini, Nasabah
menyatakan tunduk pada ketentuan-ketentuan yang tercantum dalam
Ketentuan dan Syarat Umum Pembukaan Rekening pada Bank sebagai
berikut :</p>
<p><b>Pasal 1<br />
PEMBUKAAN REKENING DANA NASABAH</b></p>

<p>1.1
PEMBUKAAN REKENING DANA NASABAH<br />
1.1.1
Pembukaan Rekening Dana Nasabah oleh Nasabah melalui
Perusahaan Efek wajib memenuhi seluruh persyaratan yang telah
ditetapkan dan atau akan ditetapkan kemudian oleh Bank, termasuk
yang bersumber dari persyaratan yang telah dan atau akan ditetapkan
kemudian oleh PT Kustodian Sentral Efek Indonesia dan atau pihak
terkait lain, seperti namun tidak terbatas pada :
a. Memiliki Sub Rekening Efek di C-Best
b. Memiliki Single Dana Nasabah Identification (SID) di Akses
c. Mengisi
dan
menyerahkan
Kuasa
dari
Nasabah
kepada
Perusahaan Efek sesuai dengan format yang telah ditentukan
dalam pembukaan Rekening Dana Nasabah.
d. Mengisi dan menandatangani Aplikasi Pembukaan Rekening,
Syarat Umum Pembukaan Rekening dan dokumen lainnya yang
dipersyaratkan
sesuai
persyaratan
administrasi
pembukaan
Rekening Dana Nasabah.
Nasabah dengan ini menyatakan serta menjamin Bank bahwa segala
data/dokumen/informasi apapun yang diberikan kepada Bank melalui
Perusahaan Efek berkenaan dengan pembukaan Rekening Dana
Nasabah Bank adalah lengkap, benar dan sesuai dengan aslinya.
Seluruh data, keterangan, informasi, pernyataan, dokumen yang
diperoleh Bank melalui Perusahaan Efek berkenaan dengan Nasabah
maupun kegiatan usaha atau transaksi Nasabah, akan menjadi milik
Bank dan Bank berhak untuk menggunakannya untuk kepentingan
Bank sesuai dengan ketentuan hukum yang berlaku tanpa kewajiban
Bank untuk memberitahukan atau meminta persetujuan terlebih dahulu
dari Nasabah, memberikan jaminan atau ganti rugi apapun dan dengan
alasan apapun kepada Nasabah.<br />
1.1.2
Pembukaan Rekening Dana Nasabah dilakukan melalui Perusahaan
Efek atas kuasa dari Nasabah kepada Perusahaan Efek sebagaimana
dituangkan dalam KPK Rekening Dana Nasabah ini.<br />
1.1.3
Bank berhak untuk menolak dan/atau menunda proses pembukaan
Rekening Dana Nasabah apabila terdapat ketidaklengkapan data/
dokumen/informasi
oleh
Nasabah
dan
oleh
karenanya
Bank
dibebaskan dari klaim, gugatan, tuntutan, dan/atau ganti kerugian yang
dialami oleh Nasabah atau pihak manapun juga.<br />
1.2
KETENTUAN REKENING DANA NASABAH<br />
1.2.1
Rekening Dana Nasabah adalah Rekening giro/ tabungan yang
diselenggarakan oleh Bank dan ditujukan bagi nasabah (perorangan)
untuk keperluan penyelesaian transaksi pasar modal.<br />
1.2.2.
Bank tidak akan menerbitkan cek/ bilyet giro/ kartu ATM/ Buku
Tabungan/ media penarikan lainnya untuk penarikan dana atas
rekening giro/ tabungan Rekening Dana Nasabah.<br />
1.2.3
Bank tidak melakukan proses Laporan Kunjungan Nasabah (LKN)
untuk pembukaan Rekening Dana Nasabah.<br />
1.2.4
Nasabah harus mendaftarkan alamat email kepada Bank untuk
pengiriman rekening koran via email (e-statement).<br />
1.3
PENANGANAN KELUHAN (PENGADUAN)<br />
Dalam hal Nasabah akan menyampaikan keluhan/pengaduan kepada
Bank
sehubungan
dengan
Rekening
Dana
Nasabah,
keluhan/pengaduan disampaikan secara langsung kepada Perusahaan
Efek,untuk
selanjutnya Perusahaan Efek berkewajiban
menindaklanjuti keluhan Nasabah tersebut kepada Bank. Bank tidak
bertanggung jawab atas
keterlambatan penanganan
keluhan yang disebabkan karena kelalaian dan/atau keterlambatan
Perusahaan Efek dalam menyampaikan keluhan Nasabah kepada
Bank.</p>

<p><b>Pasal 2<br />
KUASA</b></p>

<p>2.1
Nasabah dengan
ini menyatakan dan memberikan kuasa kepada
Perusahaan Efek untuk dan atas nama Nasabah untuk melakukan
hal-hal sebagai berikut:<br />
2.1.1
Membuka dan/atau mengurus pembukaan Rekening Dana Nasabah
atas nama Nasabah pada Bank untuk keperluan administrasi dan
penyelesaian transaksi efek milik nasabah di Bank.<br />
2.1.2
Memberikan kuasa kepada Perusahaan Efek untuk melakukan
verifikasi perihal kebenaran dan ketepatan informasi yang diberikan
oleh Nasabah.<br />
2.1.3
Mendaftarkan Rekening Dana Nasabah yang dibuka tersebut atas
nama Nasabah ke Cash Management System (CMS) Perusahaan Efek
di Bank.<br />
2.1.4
Sehubungan dengan pendaftaran rekening dalam CMS tersebut, maka
Perusahaan Efek diberikan hak untuk:<br />
a. Melihat saldo Rekening Dana Nasabah
b. Mengunduh dan menyimpan data transaksi Rekening Dana
Nasabah
c. Melakukan pendebetan Rekening Dana Nasabah, untuk setiap nilai
transaksi yang dilakukan Nasabah.
Nasabah menyatakan bahwa pemberian akses dan informasi tersebut
bukan merupakan pelanggaran atas ketentuan kerahasiaan Bank
sebagaimana diatur dalam ketentuan dan perundang-undangan yang
berlaku.<br />
2.1.5
Melakukan tindakan pengoperasian Rekening Dana Nasabah, termasuk
melakukan instruksi pemindahbukuan atau pendebitan sejumlah dana
tertentu yang terdapat dalam Rekening Dana Nasabah untuk
penyelesaian pembayaran transaksi efek Nasabah. Pendebitan
Rekening Dana Nasabah hanya dapat dilakukan untuk mengkreditkan
dana yang telah
disepakati. Atau rekening lain sebagaimana
diberitahukan secara tertulis oleh Nasabah.<br />
2.1.6
Meminta pemblokiran Rekening Dana Nasabah ke Bank berdasarkan
instruksi Nasabah.<br />
2.1.7
Meminta pembukaan pemblokiran Rekening Dana Nasabah ke Bank
(apabila pemblokiran dilakukan atas permintaan Nasabah).<br />
2.1.8
Melakukan pendaftaran Akses KSEI melalui layanan perbankan
elektronik Bank atas nama Nasabah kepada Bank.<br />
2.1.9
Meminta penutupan Rekening Dana Nasabah ke Bank berdasarkan
instruksi Nasabah.<br />
2.1.10 Nasabah memberikan kuasa kepada Perusahaan Efek untuk melakukan
penutupan Rekening Dana Nasabah berdasarkan data yang ada di
Perusahaan Efek bahwa nasabah tidak melakukan transaksi efek di
Perusahaan Efek.<br />
2.1.11 Nasabah setuju untuk membebaskan Bank dari segala tuntutan dan atau
risiko dan atau kerugian yang mungkin timbul akibat penyalahgunaan
kuasa yang dilakukan oleh Perusahaan Efek, terkait dengan dana pada
Rekening Dana Nasabah, dan bersedia untuk menanggung segala
kerugian yang dialami Bank akibat penyalahgunaan kuasa tersebut.<br />
2.1.12 Kuasa-kuasa yang diberikan oleh Nasabah kepada Perusahaan Efek
dilakukan tanpa paksaan dan tidak dapat ditarik kembali atau diubah oleh
Nasabah atau tidak akan berakhir karena sebab-sebab sebagaimana
dimaksud dalam ketentuan pasal 1813, 1814 dan 1816 KUH Perdata.<br />
2.1.13. Kuasa ini diberikan tanpa hak subtitusi, dan berlaku sejak tanggal
penandatanganan di bawah ini sampai dengan Bank menerima
pencabutan kuasa secara tertulis oleh Nasabah atau kuasa ini dengan
sendirinya akan berakhir pada saat Rekening Dana Nasabah ditutup.
</p>

<p><b>Pasal 3<br />
TRANSAKSI REKENING</b></p>

<p>3.1
PENARIKAN DAN PENYETORAN<br />
3.1.1
Penarikan atas Rekening Dana Nasabah dilakukan Perusahaan Efek
berdasarkan Kuasa dari Nasabah kepada Perusahaan Efek dan
penarikan dana tersebut hanya dapat dilakukan untuk keperluan
penyelesaian transaksi efek atau pemindahbukuan dana ke rekening
tujuan.<br />
3.1.2
Nasabah setuju untuk membebaskan Bank dari segala klaim, gugatan,
tuntutan dan/atau ganti kerugian yang mungkin timbul akibat
penyalahgunaan kuasa yang dilakukan oleh Perusahaan Efek, terkait
dengan dana pada Rekening Dana Nasabah, dan bersedia untuk
menanggung segala kerugian yang dialami Bank akibat penyalahgunaan
kuasa tersebut.<br />
3.1.3
Penarikan dana dari Rekening Dana Nasabah hanya dilakukan dengan
menggunakan media penarikan yang memenuhi ketentuan Bank tanpa
mengurangi hak Bank untuk menolak penarikan atas Rekening Dana
Nasabah, termasuk namun tidak terbatas bilamana dana dalam
Rekening Dana Nasabah tidak mencukupi dengan memperhatikan
ketentuan/
perjanjian yang berlaku.<br />
3.1.4
Penyetoran dana ke Rekening Dana Nasabah dapat dilakukan dengan
menggunakan media penyetoran yang dimiliki oleh Bank secara:<br />
1). Tunai, setiap saat selama jam pelayanan pada hari kerja Bank.
2). Pemindahbukuan, baik melalui unit kerja maupun fasilitas electronic
banking Bank.
3). Kliring dan RTGS.<br />
3.2
INSTRUKSI<br />
3.2.1
Apabila tidak ada kesepakatan lain, instruksi penyetoran dana dapat
dilakukan oleh Nasabah atau Perusahaan Efek atau pihak ketiga lainnya,
sedangkan instruksi penarikan dana dilakukan oleh Perusahaan Efek
atas dasar Kuasa dari Nasabah kepada Perusahaan Efek.<br />
3.2.2
Apabila Nasabah menginginkan untuk melakukan tindakan terkait
dengan Rekening Dana Nasabah termasuk mengeluarkan dana hasil
investasi di pasar modal dari Rekening Dana Nasabah, maka Nasabah
setuju untuk terlebih dahulu harus menghubungi Perusahaan Efek di
mana dananya diadministrasikan dalam Rekening Dana Nasabah dan
apabila hal ini disetujui oleh Perusahaan Efek maka Perusahaan Efek
akan melakukannya untuk Nasabah.</p>

<p><b>Pasal 4<br />
PEMBUKTIAN</b></p>

<p>4.1
Bank setiap saat berhak untuk memperbaiki kekeliruan yang dibuat
oleh Bank atau pegawainya baik dalam hal mengkoreksi mutasi
Rekening Dana Nasabah atau dalam menjalankan instruksi yang
berkaitan dengan hal tersebut serta Nasabah dengan ini menyatakan :<br />
4.1.1
Memberikan kuasa kepada Bank untuk melakukan koreksi mutasi dan
saldo Rekening Dana Nasabah apabila terjadi kekeliruan pembukuan
oleh Bank.<br />
4.1.2
Melepaskan haknya untuk menuntut atau meminta ganti rugi kepada
Bank atau pegawainya atas setiap kekeliruan yang akan diperbaiki
Bank dalam jangka waktu yang dipersyaratkan sesudah Bank
mengetahuinya.<br />
4.1.3
Menyetujui serta mengakui bahwa hasil atau akibat yang timbul atas
tindakan Bank dalam memperbaiki kekeliruan atas Rekening Dana
Nasabah akan berlaku dan mengikat Nasabah sebagai alat bukti yang
sah dan sempurna.</p>

<p><b>Pasal 5<br />
TANGGUNG JAWAB</b></p>

<p>5.1
Dalam hal transaksi atas Rekening Dana Nasabah dilakukan oleh
Perusahaan
Efek
berdasarkan
Kuasa
dari
Nasabah
kepada
Perusahaan Efek, melalui layanan perbankan apapun termasuk
layanan
perbankan
elektronik,
maka
Nasabah
setuju
untuk
membebaskan Bank dari segala risiko yang mungkin timbul akibat
penggunaan
layanan
perbankan
maupun
layanan
perbankan
elektronik,
termasuk namun tak terbatas pada kerugian akibat
kelalaian/kesalahan Nasabah atau kuasa Nasabah (Perusahaan Efek)
maupun kerugian akibat penggunaan atau intervensi penggunaan
layanan perbankan elektronik oleh pihak lain yang tidak berhak,
keterlambatan atau kegagalan akses atau pelaksanaan transaksi
akibat gangguan atau perbaikan sistem atau kondisi apapun yang
berada di luar kekuasaan Bank melalui force majeure, atau
penggunaan layanan perbankan elektronik yang menyimpang dari
persyaratan dan ketentuan serta prosedur yang ditetapkan Bank.<br />
5.2
Nasabah dengan ini setuju bahwa Nasabah akan menggunakan
Rekening Dana Nasabah untuk transaksi yang tidak bertentangan
dengan ketentuan peraturan perundang-undangan dan atau kebijakan
internal Bank yang berlaku dan atau peraturan–peraturan lainnya yang
berlaku.
Nasabah bertanggung jawab atas segala klaim dan tuntutan yang
timbul akibat penggunaan Rekening Dana Nasabah oleh Nasabah
untuk transaksi yang dikategorikan sebagai transaksi mencurigakan
dan/atau
transaksi
yang
dilarang
oleh
ketentuan
peraturan
perundang-undangan yang berlaku.<br />
5.3
Bank dibebaskan dari segala klaim, gugatan, tuntutan dan/atau ganti
kerugian
yang
timbul
karena
kehilangan/pemalsuan
dan/atau
penyalahgunaan, formulir-formulir dan/atau Kuasa dari Nasabah
kepada Perusahaan Efek dan/atau hal lain yang terkait dengan
Rekening Dana Nasabah.<br />
5.4
Apabila penyalahgunaan tersebut dilakukan oleh pihak ketiga dan
karenanya Bank dirugikan secara materiil dan immateriil, maka
Nasabah bersedia untuk membayar seluruh ganti kerugian dan
biaya-biaya yang timbul dengan mengesampingkan ketentuan yang
terdapat dalam Pasal 1226 dan 1267 KUHPerdata.</p>

<p><b>Pasal 6<br />
IMBALAN JASA DAN BIAYA TRANSAKSI</b></p>

<p>6.1
Dana pada Rekening Dana Nasabah diberikan jasa giro/ tabungan
sesuai dengan tarif yang berlaku di Bank dan dapat berubah
sewaktu-waktu mengikuti kebijakan Bank.<br />
6.2
Jasa giro/ tabungan akan diberikan kepada nasabah pada setiap bulan
berdasarkan saldo harian dalam bulan yang bersangkutan.<br />
6.3
Jasa giro/ tabungan yang diterima oleh nasabah akan dikenakan pajak
yang besarnya sesuai dengan ketentuan perpajakan yang berlaku.<br />
6.4
Rekening Dana Nasabah akan dikenakan biaya-biaya sehubungan
dengan transaksi yang dilakukan oleh Perusahaan Efek seperti :<br />
a. Biaya penutupan rekening
b. Biaya RTGS/Kliring
c. Biaya lain-lain sesuai ketentuan yang berlaku di Bank dan telah
diberitahukan sebelumnya oleh Bank kepada Nasabah melalui
Perusahaan Efek.</p>

<p><b>Pasal 7<br />
PENUTUPAN DAN PEMBLOKIRAN REKENING</b></p>

<p>7.1
Penutupan Rekening Dana Nasabah tidak membebaskan Nasabah
dari kewajiban yang belum dipenuhi, termasuk namun tidak terbatas
pada adanya cerukan (saldo debit) atas Rekening Dana Nasabah (bila
ada) dan Bank tetap berhak untuk menagih/mendapatkan pembayaran
dari Nasabah atas jumlah yang belum dipenuhi oleh Nasabah.<br />
7.2
Apabila setelah ditutupnya Rekening Dana Nasabah masih terdapat
sisa dana dalam Rekening Dana Nasabah, maka sisa dana dalam
rekening yang ditutup tetap menjadi milik Nasabah dan Bank akan
mengkreditkan dana tersebut ke rekening lain milik Nasabah di BRI
sesuai dengan instruksi setelah dipotong biaya penutupan Rekening
Dana Nasabah dan biaya-biaya lainnya yang dikenakan terkait dengan
penutupan Rekening Dana Nasabah tersebut .<br />
7.3
Nasabah memberikan kuasa kepada Perusahaan Efek untuk
melakukan penutupan Rekening Dana Nasabah berdasarkan data yang
ada di Perusahaan Efek bahwa nasabah tidak melakukan transaksi efek
di Perusahaan Efek.
7.4
Untuk Pemblokiran Rekening Dana Nasabah dilakukan oleh Bank atas
dasar :
i. Permintaan
Nasabah
melalui
Perusahaan
Efek
dengan
melampirkan
surat
permintaan
pemblokiran/penutupan
dari
Nasabah.
ii. Perintah instansi yang berwenang sesuai dengan ketentuan dan
perundangan yang berlaku.
7.5
Nasabah dan atau ahli waris membebaskan Bank dari seluruh tanggung
jawabnya berkenaan dengan penutupan dan atau pemblokiran
Rekening Dana Nasabah tersebut.
</p>


<p><b>Pasal 8<br />
KETENTUAN LAIN-LAIN</b></p>

<p>8.1
Dalam hal Nasabah hendak melakukan perubahan data, termasuk
namun tidak terbatas pada perubahan alamat, nomor telepon, faksimili,
Kartu Tanda Penduduk, Nomor Pokok Wajib Pajak (NPWP),
tandatangan pejabat yang berwenang menandatangani (berikut contoh
tandatangan baru), susunan pengurus, status badan hukum, perizinan
dan lain-lainnya, maka Nasabah wajib menginformasikan perubahan
tersebut melalui Perusahaan Efek. Perubahan ini efektif berlaku sejak
diterima dan dicatatnya perubahan dimaksud dalam catatan Bank.<br />
8.2
Untuk kepentingan atas nama rekening dan atas dasar alasan yang
dapat dipertanggungjawabkan, Bank sewaktu-waktu dapat melakukan
perubahan atas Ketentuan dan Persyaratan Khusus Rekening Dana
Nasabah ini.<br />
8.3
Dengan menandatangani Ketentuan dan Persyaratan Khusus ini,
Nasabah memberikan persetujuan kepada Bank untuk memberikan
informasi dan data pribadi serta informasi dan data rekening, saldo dan
mutasi Rekening Dana Nasabah atas nama Nasabah berdasarkan
Kuasa dari Nasabah kepada Perusahaan Efek/KSEI/pihak lainnya
sesuai ketentuan dan perundangan yang berlaku untuk tujuan berkaitan
dengan Rekening Dana Nasabah serta tidak dikategorikan sebagai
pelanggaran atas ketentuan Rahasia Bank.<br />
8.4
Apabila nasabah meninggal dunia/pailit/dibubarkan maka:<br />
i. Bank dapat sewaktu-waktu berhak untuk melakukan penutupan
Rekening Dana Nasabah secara administratif untuk sementara, dan
hanya akan mengalihkan hak atas nama ahli waris yang sah atau
pihak yang ditunjuk tersebut, sesuai ketentuan Bank maupun
perundangan yang berlaku.<br />
ii. Bank berhak meminta dokumen yang dapat diterima sebagai bukti
yang sah tentang kedudukannya sebagai ahli waris atau pengganti
hak.<br />
iii. Ketentuan terkait dengan Nasabah yang meninggal/pailit/dibubarkan
mengacu pada ketentuan umum yang berlaku di Bank.<br />
8.5
Ketentuan dan Persyaratan Khusus Rekening Dana Nasabah ini
merupakan satu kesatuan yang tidak terpisahkan dari Syarat-Syarat
Umum Pembukaan Rekening Bank dan ketentuan yang berlaku di
Bank.<br />
8.6
Setiap sengketa yang timbul dan tidak dapat diselesaikan secara
musyawarah, akan diselesaikan melalui Badan Arbitrase Pasar Modal
Indonesia (BAPMI).</p>


<p><b>Pasal 9<br />
PENUTUP</b></p>

<p>9.1
Dalam hal terdapat perbedaan pengaturan dalam Ketentuan dan
Persyaratan Umum Pembukaan Rekening dengan KPK Rekening Dana
Nasabah ini maka yang berlaku adalah pengaturan dalam KPK
Rekening Dana Nasabah ini.<br />
9.2
Nasabah dengan ini menyatakan telah menerima Ketentuan dan
Persyaratan Umum Pembukaan Rekening, membaca, memahami,
menandatangani dan menyetujui isinya dan Bank telah memberikan
penjelasan yang cukup mengenai karakteristik Rekening Dana
Nasabah. Nasabah telah mengerti dan memahami segala konsekuensi
pemanfaatan Rekening Dana Nasabah, termasuk manfaat, risiko, dan
biaya-biaya yang melekat pada Rekening Dana Nasabah tersebut.
Perjanjian
ini
telah
disesuaikan
dengan
ketentuan
peraturan
perundang-undangan termasuk ketentuan peraturan Otoritas Jasa
Keuangan.
Demikian Ketentuan dan Persyaratan Khusus Rekening Dana Nasabah
ini telah dibaca, dipahami, isinya telah dimengerti dan disetujui oleh
Nasabah.</p>


                        <br /><br />
                        <FormGroup check>
                            <Label check>
                                <Input type="checkbox" name="AgreeKetentuan" id="AgreeKetentuan" onClick={(e) => onAgree(e, setFieldValue)} 
                                checked={values.AgreeKetentuan}
                                invalid={errors.AgreeKetentuan && touched.AgreeKetentuan}/>
                                <b> Saya dengan ini menyatakan telah membaca, memahami, dan menyetujui isi dari ketentuan terkait dengan Rekening
                                     Dana Nasabah di BRI sebagaimana tersebut di atas<span className="text-danger">*</span>.</b>    
                                     {errors.AgreeKetentuan && touched.AgreeKetentuan ? (
                            <FormFeedback>{errors.AgreeKetentuan}</FormFeedback>
                        ) : null}
                                     </Label>
                        </FormGroup>
                        <br /><br />
                    </div>
                    <br /><br />
                
                   
            </FormGroup>
                </Fade>
            
            </React.Fragment>
        )
    }
}

export default Page5AgreementPernyataan;


// WEBPACK FOOTER //
// ./src/components/Page5AgreementPernyataanBRI.js